import { useState } from 'react';

export function useStateWithPartialSet<T extends object | undefined>(initialValue: T): [T, ReactPartialDispatch<T>] {
    const [state, setState] = useState<T>(initialValue);

    function setStatePartial(partialState: Partial<T>) {
        setState({ ...state, ...partialState });
    }

    return [state, setStatePartial];
}

export type ReactPartialDispatch<T> = React.Dispatch<Partial<T>>;
